import { kitopiColors, type PartialAuthUiTheme } from '@kitopi-com/customer-auth';
import bgDesktop from '../../assets/images/bg-desktop.svg';
import bgMobile from '../../assets/images/bg-mobile.svg';
import bgTablet from '../../assets/images/bg-tablet.svg';

export const customTheme: PartialAuthUiTheme = {
  fontFamilies: {
    en: 'Lexend',
    ar: 'Lexend',
  },
  authForm: {
    trigger: {
      backgroundColor: kitopiColors.neutral0,
      borderRadius: '8px',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s',
    },
    providerButton: {
      gap: '10px',
    },
  },
  modal: {
    backdrop: {
      backgroundColor: kitopiColors.kitopiWhite,
      opacity: 0.7,
      transitionDuration: '0.3s',
    },
    popup: {
      backgroundColor: kitopiColors.neutral0,
      borderRadius: '8px',
      boxShadow: '0px 2px 12px 0 rgba(0, 0, 0, 0.2)',
      transition: 'transform 0.3s',
    },
  },
  fullPageAuth: {
    background: {
      mobile: {
        type: 'image',
        value: bgMobile,
        fallback: 'linear-gradient(135deg, #00B4DB 0%, #0083B0 100%)',
      },
      tabletPortrait: {
        type: 'image',
        value: bgTablet,
        fallback: 'linear-gradient(135deg, #00B4DB 0%, #0083B0 100%)',
      },
      tabletLandscape: {
        type: 'image',
        value: bgDesktop,
        fallback: 'linear-gradient(135deg, #00B4DB 0%, #0083B0 100%)',
      },
      desktop: {
        type: 'image',
        value: bgDesktop,
        fallback: 'linear-gradient(135deg, #00B4DB 0%, #0083B0 100%)',
      },
    },
  },
};
